import React, { useState, useEffect } from "react";
import x_icon_cancel from '../../../../icons/x_icon_cancel.svg';
import { usePreview } from "../../../../context/PreviewContextProvider";

const SalePopup = ({
  sliders,
  card,
  show,
  saleStatus,
  onClose,
  onCancel,
  onSale,
  onChangePrice,
}) => {
  // Retrieve campaign and data from custom context
  const { data } = usePreview();

  // State to manage the active price entered by the user
  const [activePrice, setActivePrice] = useState(card.originalPrice);

  // Handle price input change, allowing only up to 2 decimal places
  const handleChange = (aa) => {
    onChangePrice(aa);
    setActivePrice(aa);
  };

  // Reset the active price when the popup is shown or closed
  useEffect(() => {
    setActivePrice(card.originalPrice);
  }, [show]);

  return (
    <div className="salepopup">
      {/* Close button */}
      <div className='close-btn__wrapper' onClick={onClose}>
        <span><img className="x_icon_cancel" src={x_icon_cancel} alt="close"></img></span>
      </div>

      {/* Title changes based on sale status */}
      <h1 className="salepopup__title" style={{ color: data.web_main_color }}>
        {saleStatus === "Sell"
          ? `Sell ${card.name === "" || card.name === null ? "NFT" : card.name}`
          : `Cancel ${card.name === "" || card.name === null ? "NFT" : card.name} Sale`}
      </h1>

      <div className="salepopup__info-box">
        {/* Left section for NFT image preview */}
        <div className="salepopup__info-box-left">
          <div className="mint-card">
            <img className="nft-img" src={card.image} alt="NFT"></img>
          </div>
        </div>

        {/* Right section for NFT details and sale options */}
        <div className="salepopup__info-box-right">
          <table className="sale-price">
            <tbody>
              {/* NFT Title */}
              <tr>
                <td className="table-text-data">
                  <h3 className="card__title" style={{ color: data.web_main_color }}>
                    {card.name === null ? "NFT" : card.name}
                  </h3>
                </td>
              </tr>

              {/* Shortened Wallet Address */}
              <tr>
                <td className="table-text-data">
                  <span>
                    {card.address.slice(0, 6)}...{card.address.slice(card.address.length - 4)}
                  </span>
                </td>
              </tr>

              {/* Display last price */}
              <tr>
                <td className="table-text-data">Last Price:</td>
                <td className="table-text-data">{card.originalPrice} AVAX</td>
              </tr>

              {/* Input for new sale price or display current price */}
              <tr>
                <td className="table-text-data">Sell Price (AVAX):</td>
                <td className="table-text-data">
                  {saleStatus === "Sell" ? (
                    <input
                      className="sale-price__input"
                      onInput={(e) => handleChange(e.target.value)}
                      type="number"
                      min="0"
                      step=".01"
                      placeholder={card.originalPrice}
                      value={activePrice}
                    ></input>
                  ) : (
                    `${card.price} AVAX`
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Display action buttons based on sale status */}
          {saleStatus === "Sell" ? (
            <button
              className="sale-btn"
              style={{ backgroundColor: data.web_main_color, borderColor: data.web_main_color }}
              onClick={onSale}
              disabled={activePrice === "" || activePrice === undefined}
            >
              Place {card.name === "" || card.name === null ? "NFT" : card.name} for Sale
            </button>
          ) : (
            <button
              className="sale-btn"
              style={{ backgroundColor: data.web_main_color, borderColor: data.web_main_color }}
              onClick={onCancel}
            >
              Cancel Sale
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalePopup;
